import { render } from "./AddFacilityGroupModal.vue?vue&type=template&id=3a485f10&scoped=true&ts=true"
import script from "./AddFacilityGroupModal.vue?vue&type=script&lang=ts"
export * from "./AddFacilityGroupModal.vue?vue&type=script&lang=ts"

import "./AddFacilityGroupModal.vue?vue&type=style&index=0&id=3a485f10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a485f10"]])

export default __exports__